import React from "react";
import "./Common_Service_Card.css";
import { Container, Row, Col } from "react-bootstrap";

const Common_Service_Card = ({ title, image, title2, subtitle }) => {
  return (
    <div className="common-card">
      {title && <h4 className="card-title">{title}</h4>}
      <div className="card-wrapper">
        <div className="card-image">
          <img src={image} alt={title} className="img" />
        </div>
        <div className="text_holder">
          {title2 && <h5 className="card-title-2">{title2}</h5>}
          {subtitle && <p className="card-subtitle ">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default Common_Service_Card;
